import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { ActivityDetailList, ActivityCostPakagesTable } from "../components";
import * as _activity from "../redux";

export const ActivityDetail = (props) => {
    const {
        activityID,
        getDetail,
        activity,
        loading,
        extraProps
    } = props;

    useEffect(() => {
        if (activityID) {
            getDetail(activityID);
        }
    }, [activityID, getDetail]);

    const base_op = {
        className: "activity_list",
        breadcrumbs: [
            { name: "Home", rel: "/", icon: "home" },
            { name: "Activity Management", rel: "/activity/" },
            { name: `Activity ${activity ? activity.activity_name : ""}` }
        ],
        extraProps,
        loading
    };

    return (
        <Base {...base_op}>
            <ActivityDetailList activity={activity} />
            <ActivityCostPakagesTable
                items={activity ? activity.cost_packages : []}
            />
        </Base>
    );
};

const mapStateToProps = (store, ownProps) => {
    return {
        activity: store.activity.activity,
        activityID: ownProps.match.params.activityID,
        loading: store.activity.loading,
        loaded: store.activity.loaded
    };
};

const mapDispatchToProps = dispatch => ({
    getDetail: activity_id => dispatch(_activity.actions.getActivityDetail(activity_id))
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityDetail);